import Repository from './Repository'

export default class CrudRepository {
  constructor (resource) {
    this.resource = resource
  }

  // async getPage (page = 0, perPage = 8, pagination = true) {
  //   const paginationRequest = (pagination === true) ? 1 : 0
  //   const requestParams = {
  //     page: page - 1,
  //     size: perPage,
  //     is_pagination: paginationRequest
  //   }
  //
  //   const data = await Repository.get(this.resource, {
  //     params: pagination ? requestParams : null
  //   })
  //   const requestData = data
  //   return {
  //     content: (pagination === true) ? requestData.data.data.data : page,
  //     totalPage: (pagination === true) ? requestData.data.data.totalPages : null,
  //     perPage: (pagination === true) ? requestData.data.data.size : null,
  //     count: (pagination === true) ? requestData.data.data.totalElements : null
  //   }
  // }

  async get () {
    const data = await Repository.get(`${this.resource}`)
    return data.data
  }

  async getWithParams (config) {
    const data = await Repository.get(`${this.resource}`, config)
    return data.data
  }

  async getById (id) {
    const data = await Repository.get(`${this.resource}/${id}`)
    return data.data
  }

  async getParamsById (id, page, size) {
    const data = await Repository.get(`${this.resource}/${id}`, { params: { page: page, size: size } })
    return data.data
  }

  async getPage (page, size) {
    const data = await Repository.get(`${this.resource}`, { params: { page: page, size: size } })
    return data.data
  }

  async post (item) {
    const data = await Repository.post(`${this.resource}`, item)
    return data
  }

  async put (item) {
    const data = await Repository.put(`${this.resource}`, item)
    return data
  }

  async edit (item, id) {
    const data = await Repository.patch(`${this.resource}/${id}`, item)
    return data
  }

  async delete (id) {
    const data = await Repository.delete(`${this.resource}/${id}`)
    return data
  }

  toFormData (object, data) {
    const keysArray = []
    let i = 0
    Object.keys(object).forEach(function (key, index) {
      // key: the name of the object key
      // index: the ordinal position of the key within the object
      keysArray[index] = key
    })
    const formData = new FormData()
    for (i; i < data.length; i++) {
      if (keysArray[i + 2] === 'images') {
        let j = 0
        for (j; data[i].length > j; j++) {
          formData.append('images[' + j + '][image]', data[i][j].image)
        }
        // k;sdg
      } else {
        formData.append(keysArray[i + 2], data[i])
      }
    }
    return formData
  }
}
